import {Outlet, useLoaderData, useLocation, useNavigate, useNavigation} from "react-router-dom";
import HeaderComponent from "./HeaderComponent";
import LeftNavComponent from "./LeftNavComponent";
import PreloaderComponent from "../../components/UI/PreloaderComponent";
import {getUser} from "../../api/auth";
import {useEffect} from "react";

export async function loader() {
  try {
    let user = await getUser()
    if(!user && window.location.pathname !== '/login'){
      window.location.replace(`/login`);
    } else {
      return user
    }
  } catch (error) {
      if(window.location.pathname !== '/login'){
        window.location.replace(`/login`);
      }
  }

}

const RootLayout = () => {
  const location = useLocation();
  const navigation = useNavigation();
  const navigate = useNavigate();

  const user = useLoaderData();

  useEffect(() => {
    if (!user && location.pathname !== '/login') {
      navigate('/login');
    }
  }, []);


  if (location.pathname === '/login') {
    document.body.classList.add(
      'login_page'
    );
  } else {
    document.body.classList.remove('login_page');
  }

  return (
    <>
      {navigation.state === "loading" && <PreloaderComponent />}
      <div id="wrap" className={location.pathname !== '/login' ? 'has_left_menu' : ""}>
        {location.pathname === '/login' ?
          <Outlet /> :
          <>
            <HeaderComponent />
            <LeftNavComponent />
            <div id="content_wrap">
              <div className="container">
                <Outlet />
              </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default RootLayout;